<template>
  <pagesAboutComponent
    :pageData="data"
  />
</template>

<script setup>
// 1
defineI18nRoute({
  paths: {
    en: '/about',
    nl: '/over'
  }
})

// 2
const queryPath = queryAboutPage(baseStrapiGetSlugQueryObjectFromRoute())
const { data, error } = await useAsyncData(() => {
  return $fetch('/api/strapi-rest',
    { query: { path: queryPath } }
  )
})

if (!data?.value?.data?.id || error?.value) {
  throw createError({ statusCode: 404 })
}

pageSetHead(data)
</script>
